import { h } from "../dom.js";

/** A modal built on <dialog>. `close()` removes it from the page. */
export class Dialog {
  readonly el: HTMLDialogElement;
  readonly body: HTMLElement;
  readonly footer: HTMLElement;

  constructor(title: string, wide = false) {
    this.body = h("div", { class: "dialog-body" });
    this.footer = h("div", { class: "dialog-footer" });
    this.el = h(
      "dialog",
      { class: wide ? "wide" : "" },
      h("header", { class: "dialog-header" }, h("h2", null, title), h("button", { class: "icon", type: "button", "aria-label": "Close", onclick: () => this.close() }, "✕")),
      this.body,
      this.footer,
    );
    this.el.addEventListener("close", () => this.el.remove());
  }

  open(): void {
    document.body.appendChild(this.el);
    this.el.showModal();
  }

  close(): void {
    if (this.el.open) this.el.close();
    this.el.remove();
  }
}
